/* jshint eqnull:true */
define(["jquery",
        "domReady",
        "wcs.product-price",
        "wcs.product-views-util",
        "wcs.product-views-swatches"
        ],
        function($, domReady, pdpPrice, viewUtil, swatches ) {

    var $productDetailDrawerDescriptionImage,
        $productBadge,
        $selectedSwatchColor,
        isItemBadgeEnabled = false;

    domReady( function () {

        //initialize product video on PDP and Quick View
        // VFDP-20158- don't load in checkout pages - VideoJS causes js errors that prevent hopup modal from closing.
        if ( $('#checkout').length ) return;

        var isVideoInit = false;
        $productDetailDrawerDescriptionImage = $('.product-details-drawer-container .drawer-description-image');
        $productBadge = $('.product-views-promo-badge-image');
        $selectedSwatchColor = $('.product-content-form-attr-container .attr-box.selected .color-swatch-button-content');

        if (typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.get('PDP::skuLevelBadgeAttributeEnabled')) {
            isItemBadgeEnabled = true;
        }

        // The badge loaded by backend is not reliable, it forces badge reload according to the current swatch selection
        if (isItemBadgeEnabled && $productBadge && $productBadge.length > 0 && $selectedSwatchColor && $selectedSwatchColor.length === 1) {
            var dataSelectedSwatchColor = $selectedSwatchColor.data();
            viewUtil.pdpUpdatePage.updateProductBadge(dataSelectedSwatchColor.badgesrc, dataSelectedSwatchColor.badgeattrvalue, $productBadge);
        }

        //on PDP with VFDP viewer the 'init.viewer.complete' Event will have already been dispatched during page load - we must init now
        if( $('.vfdp-s7-viewer').length && typeof wcsPDPVideoConfig !== 'undefined' && !isVideoInit ) {
            initializeProductVideos();
            isVideoInit = true;
        } else { //for quick view and legacy zoom viewer we listen for the event that viewer is initialized
            document.addEventListener('init.viewer.complete', function(event) {
                if( typeof wcsPDPVideoConfig !== 'undefined') {
                    initializeProductVideos();
                    isVideoInit = true;
                }
            }, false);
        }

        $.pubsub('subscribe', 'product-form.attr.swatch.click', handleProductFormSwatchClick);

    });

    function handleProductFormSwatchClick(msg, event){

        var dataImage = $(event.target).data();
        var preventDataLayerPush = event.preventDataLayerPush || false;

        if(!preventDataLayerPush) {
            pushDetailsToDataLayer('productDetailColorClick', dataImage);
        }

        viewUtil.pdpUpdatePage.updateProductName(dataImage.productName, dataImage.productUrl);
        viewUtil.pdpUpdatePage.updateProductPartNumber(dataImage.partNumber);

        if (dataImage.productDescUpdateEnabled === true) {
            viewUtil.pdpUpdatePage.updateProductDesc(dataImage.productDesc);
        }

        if (isItemBadgeEnabled && $productBadge && $productBadge.length > 0) {
            viewUtil.pdpUpdatePage.updateProductBadge(dataImage.badgesrc, dataImage.badgeattrvalue, $productBadge);
        }

        if ($productDetailDrawerDescriptionImage && $productDetailDrawerDescriptionImage.length > 0) {
            viewUtil.pdpUpdatePage.updateProductDetailDrawerDescriptionImage(dataImage.descriptionImage, $productDetailDrawerDescriptionImage);
        }

        $.pubsub('publish', 'product-form.product-viewer.swatch.click.complete');
    }

    function handleContextChangePDP () {
        $('.product-img-js').parents('.product-context-js').on('PRODUCT_CONTEXT_CHANGED', function(e) {
            $('div.product-img-js .product-view-control-js.secondary').remove();
            $('div.product-img-js .product-view-control-js').css('display', '');
            setupPDP();
        });
    }

    function handleContextChangeQuickshop () {
        $('.product-img-js').parents('.product-context-js').on('PRODUCT_CONTEXT_CHANGED', function(e) {
            setupQuickshop();
        });
    }

	function setupQuickshop () {
		$(".product-content-container").find('.product-form-js').productPrices();
		viewUtil.quickViewInitialSetup();
		swatches.pdpAndQuickViewInitialSetup();
	}

    function setupPDP () {
        $('.product-form-js').productPrices();
        viewUtil.pdpInitialSetup();
        swatches.pdpAndQuickViewInitialSetup();
        if( $('.product-compare-container-js').length !== 0 ) {
            require( ["wcs.product-views-equipment-compare"], function ( productCompare ) {
                productCompare.init();
            });
        }

    }

    function initializeProductVideos () {

        require( ["wcs.product-video-controller"], function ( pdpVideos ) {
            pdpVideos.initializeVideo();
        });

    }

    function getCurrencyData() {
        var currencyCode;
        var currencySymbol;
        var jsonData;
        if (window.dataLayer) {
            for (var i in window.dataLayer) {
                jsonData = window.dataLayer[i];
                currencyCode = jsonData.currency;
                currencySymbol = jsonData.currencySymbol;
                if (currencySymbol) {
                    currencySymbol = currencySymbol.replace(/&amp;/g, '&');
                    currencySymbol = $('<textarea/>').html(currencySymbol).text();
                    window.dataLayer[i].currencySymbol = currencySymbol;
                    break;
                }
            }
        }
        return {
            currencySymbol: currencySymbol,
            currencyCode: currencyCode
        };
    }

    function pushDetailsToDataLayer(event, productData) {
        var currencyData = getCurrencyData();
        var dataLayerObj = {
            "event": event,
            "ecommerce": {
                "currencyCode": currencyData.currencyCode ? currencyData.currencyCode : null,
                "currencySymbol": currencyData.currencySymbol ? currencyData.currencySymbol : null
            }
        };

        if (event === 'productDetailColorClick') {
            var productObj = {
                "id": productData.partNumber,
                "sku": productData.partNumber,
                "productID": productData.partNumber,
                "name": productData.productName
            };

            if(productData.productData) {
                productObj.colorDescription = productData.productData.colorDescription ? productData.productData.colorDescription : '';
                productObj.styleCode = productData.productData.styleCode ? productData.productData.styleCode : '';
                productObj.colorCode = productData.productData.colorCode ? productData.productData.colorCode : '';
            }

            dataLayerObj.ecommerce.detail = {
                "actionField": {
                    "list": "fullpdp"
                },
                "products": [productObj]
            };
        }

        try {
            window.dataLayer.push(dataLayerObj);
        } catch (err) {
            console.error('Failed push to dataLayer', err);
        }
    }

    return {
        setupPDP: setupPDP,
        setupQuickshop: setupQuickshop,
        handleContextChangePDP: handleContextChangePDP,
        handleContextChangeQuickshop: handleContextChangeQuickshop
    };
});
